import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=5963a6bd&scoped=true"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"
import style0 from "./ContactPage.vue?vue&type=style&index=0&id=5963a6bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5963a6bd",
  null
  
)

export default component.exports